<template>
  <div id="dg__xiaojin" class="z-[5001]" ref="xiaojin">
    <div class="relative z-[2002]">
      <div class="xiaojin-img">
        <div class="qipao" v-show="qipao">
          <div class="qipao-item">
            <img
              width="92"
              height="34"
              src="@/assets/img/xiaojin/qipao.png"
              alt=""
            />
            <p
              class="leading-[28] t-[theme] relative t-[12] text-center font-600"
            >
              有事找小金<i
                class="el-icon-close ml-[4] cursor-pointer"
                @click="qipao = false"
              ></i>
            </p>
          </div>
        </div>

        <img
          id="img"
          @mouseover="mouseover"
          width="58"
          height="85"
          class="img"
          :src="xiaojin"
          alt=""
          @click="isShow = !isShow"
        />
      </div>
      <div class="xiaojin-list">
        <div class="content" v-show="isShow">
          <el-popover
            placement="left-start"
            width="224"
            trigger="hover"
            popper-class="popper-my"
          >
            <div slot="reference" class="item cursor-pointer">
              <!-- <i class="hover-icon el-icon-caret-left"></i> -->
              <div>
                <p><i class="icon t-[28]">&#xe6bd;</i></p>
                <p class="t-[12]">我的</p>
              </div>
            </div>
            <div class="my-pop">
              <div class="pb-[8] tit t-[#606266] t-[12]">快捷入口</div>
              <div class="pt-[8] pb-[4] flex justify-between">
                <div
                  class="text-center w-[48] cursor-pointer"
                  @click="routerHref(0)"
                >
                  <img
                    width="32"
                    height="32"
                    :src="getCityAssetsFile('xiao_xi.png')"
                    alt=""
                  />
                  <p class="t-[#303133] t-[12]">我的消息</p>
                </div>
                <div
                  class="text-center w-[48] cursor-pointer"
                  @click="routerHref(1)"
                >
                  <img
                    width="32"
                    height="32"
                    :src="getCityAssetsFile('order.png')"
                    alt=""
                  />
                  <p class="t-[#303133] t-[12]">我的订单</p>
                </div>
                <div
                  class="text-center w-[48] cursor-pointer"
                  @click="routerHref(2)"
                >
                  <img
                    width="32"
                    height="32"
                    :src="getCityAssetsFile('bao_han.png')"
                    alt=""
                  />
                  <p class="t-[#303133] t-[12]">保函申请</p>
                </div>
              </div>
            </div>
          </el-popover>
          <el-popover
            placement="left-start"
            width="104"
            trigger="hover"
            popper-class="popper-kefu"
          >
            <div slot="reference" class="item cursor-pointer">
              <div>
                <p><i class="icon t-[28]">&#xe6b2;</i></p>
                <p class="t-[12]">客服微信</p>
              </div>
            </div>
            <div class="kefu-pop text-center">
              <p>客服微信</p>
              <img
                width="80"
                height="80"
                v-if="copyright.customerServiceWechatQrcode"
                :src="copyright.customerServiceWechatQrcode"
                alt=""
              />
            </div>
          </el-popover>
          <el-popover
            placement="left-start"
            width="180"
            trigger="hover"
            popper-class="popper-phone"
          >
            <div slot="reference" class="item cursor-pointer">
              <div>
                <p><i class="icon t-[28]">&#xe6b3;</i></p>
                <p class="t-[12]">客服电话</p>
              </div>
            </div>
            <div class="my-phone">
              <div
                v-if="copyright.customerServiceTime || copyright.customerServiceTime2">
                <div class="pb-[6] t-[#606266] t-[12]">
                  <i class="icon t-[14] t-[#606266]">&#xe72e;</i>
                  服务时间：工作日
                </div>
                <p
                  class="t-[14] t-[#303133] pl-[16]"
                  v-if="copyright.customerServiceTime"
                >
                  {{ copyright.customerServiceTime }}
                </p>
                <p
                  class="t-[14] t-[#303133] pl-[16]"
                  v-if="copyright.customerServiceTime2"
                >
                  {{ copyright.customerServiceTime2 }}
                </p>
              </div>
              <el-divider
                class="mt-[14] mb-[0]"
                v-if="copyright.customerServiceMobile"
              ></el-divider>
              <div class="pt-[14]" v-if="copyright.customerServiceMobile">
                <div class="flex items-center">
                  <img
                    class="mr-[4]"
                    width="16"
                    height="16"
                    src="@/assets/img/xiaojin/cell.png"
                    alt=""
                  />
                  <span>手机号</span>
                </div>
                <p class="t-[14] t-[#303133] mt-[4] pl-[16]">
                  {{ copyright.customerServiceMobile }}
                </p>
              </div>
              <div
                class="pt-[14]"
                v-if="copyright.customerServicePhone || copyright.customerServicePhone2">
                <div class="flex items-center">
                  <img
                    class="mr-[4]"
                    width="16"
                    height="16"
                    src="@/assets/img/xiaojin/phone.png"
                    alt=""
                  />
                  <span>固定电话</span>
                </div>
                <p
                  class="t-[14] t-[#303133] pt-[6] pl-[16]"
                  v-if="copyright.customerServicePhone"
                >
                  {{ copyright.customerServicePhone }}
                </p>
                <p
                  class="t-[14] t-[#303133] pt-[6] pl-[16]"
                  v-if="copyright.customerServicePhone2"
                >
                  {{ copyright.customerServicePhone2 }}
                </p>
              </div>
            </div>
          </el-popover>
          <el-popover
            :close-delay="0"
            placement="left-start"
            width="152"
            trigger="hover"
          >
            <div slot="reference" class="item cursor-pointer">
              <div>
                <p><i class="icon t-[28]">&#xe69f;</i></p>
                <p class="t-[12]">反馈咨询</p>
              </div>
            </div>
            <div class="my-pop">
              <div class="pb-[8] tit t-[#606266] t-[12]">业务相关</div>
              <div class="pt-[8] pb-[4] flex justify-between">
                <div
                  class="text-center w-[48] cursor-pointer"
                  @click="openHelp(1)"
                >
                  <img
                    width="32"
                    height="32"
                    :src="getCityAssetsFile('xiao_xi.png')"
                    alt=""
                  />
                  <p class="t-[#303133] t-[12]">问题建议</p>
                </div>
                <div
                  class="text-center w-[48] cursor-pointer"
                  @click="openHelp(2)"
                >
                  <img
                    width="32"
                    height="32"
                    :src="getCityAssetsFile('bao_han.png')"
                    alt=""
                  />
                  <p class="t-[#303133] t-[12]">咨询帮助</p>
                </div>
              </div>
            </div>
          </el-popover>
        </div>
        <div class="show-btn" @click="isShow = !isShow">
          <div class="btn-item">
            <img
              width="16"
              height="16"
              :src="isShow ? shouqi : zhankai"
              alt=""
            />
            <span v-show="isShow" class="t-[#606266] t-[12] ml-[4]">收起</span>
          </div>
        </div>
      </div>
      <!--  -->
      <div
        class="w-[365] absolute z-[9003] right-[0]"
        :class="{ 'top-[500]': helpType == 2, 'bottom-[0]': helpType == 1 }"
        v-if="showHelp"
      >
        <div
          v-if="helpType == 1"
          class="help-box z-[9004] w-[365] bg-[#FFFFFF] absolute bottom-[0] left-[0] p-[20]"
        >
          <div class="h-[22] flex justify-between items-center t-[#303133]">
            <span class="t-[16]">问题建议</span>
            <i class="icon" @click="closeHelp">&#xe641;</i>
          </div>
          <!-- 反馈成功 -->
          <div class="w-[100%] text-center h-[528]" v-if="showSuccess">
            <img
              class="h-[180] w-[180] mt-[100]"
              :src="getCityAssetsFile('feedback-success.png')"
              alt=""
            />
            <p class="t-[#192530] t-[14]">感谢您的反馈！</p>
          </div>
          <!-- 上传问题 -->
          <div class="w-[100%] text-center" v-else>
            <div
              class="bg-[themeBrightColor9] h-[26] w-[100%] mt-[8] rounded-[2] flex justify-start items-center px-[8]"
            >
              <img
                height="16"
                width="16"
                :src="getAssetsFile('public/help-icon.png')"
                alt=""
              />
              <p class="t-[12] t-[themeBrightColor3] pl-[2]">
                诚挚感谢您的反馈，这对我们非常重要！
              </p>
            </div>
            <div class="help-type mt-[8]">
              <div
                class="relative h-[32] w-[100%] flex justify-around items-center"
              >
                <div
                  v-for="item in allFeedbackType"
                  :key="item.key"
                  @click="changeServiceType(item.key)"
                  class="h-[32] border-b-[2] border-[theme] relative z-[100] leading-[32] t-[#303133] t-[12] cursor-pointer"
                  :class="{
                    '!t-[theme] border-solid': formData.serviceType == item.key,
                  }"
                >
                  {{ item.value }}
                </div>
                <!-- <div @click="changeServiceType(1)"
                  class="h-[32] border-b-[2] border-[theme] relative z-[100] leading-[32] t-[#303133] t-[12] cursor-pointer"
                  :class="{ '!t-[theme] border-solid': formData.serviceType == 1 }">
                  需求建议</div> -->
                <div
                  class="bg-[#E4E7ED] h-[2] w-[100%] absolute left-[0] bottom-[0]"
                ></div>
              </div>
              <dg-alert-box></dg-alert-box>
              <div class="help-form mt-[16] h-[376] w-[330]">
                <!-- <div class="h-[35]"> -->

                <!-- </div> -->
                <el-form
                  :model="formData"
                  ref="formData"
                  label-suffix="："
                  size="small"
                  :rules="rules"
                  label-width="94px"
                  inline
                  label-position="left"
                  align="left"
                >
                  <div class="form-content h-[342]">
                    <el-form-item label="标题" prop="title">
                      <el-input
                        v-model="formData.title"
                        placeholder="请输入标题"
                        class="w-[230]"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="描述" prop="content">
                      <el-input
                        type="textarea"
                        clearable
                        :autosize="{ minRows: 4 }"
                        :rows="4"
                        class="w-[230]"
                        size="mini"
                        v-model="formData.content"
                        placeholder="请输入需求场景、问题、期待效果"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="附件" prop="attachment">
                      <div
                        class="w-[230] t-[12] t-[#909399] leading-[20] py-[4]"
                      >
                        支持pdf、jpg、jpeg、png、doc格式，每份大小不超过50M，最多上传6张
                      </div>
                      <dg-upload-list
                        :imgBtn="true"
                        fileName="附件"
                        :fileSize="50"
                        v-model="formData.attachment"
                        @input="inputImg"
                        objName="attachment"
                        :index="6"
                        @hanldeDel="hanldeDel"
                      >
                        <img
                          height="80"
                          width="80"
                          src="@/assets/img/public/dg-upload1.png"
                          alt=""
                        />
                      </dg-upload-list>
                    </el-form-item>
                    <el-form-item label="联系电话" prop="mobile">
                      <el-input
                        v-model="formData.mobile"
                        placeholder="请输入联系电话"
                      ></el-input>
                    </el-form-item>
                  </div>
                  <el-button
                    type="primary"
                    class="w-[325]"
                    size="small"
                    @click="hanldeSubmit"
                    >提交</el-button
                  >
                </el-form>
              </div>
            </div>
          </div>
        </div>
        <div
          v-else
          class="help-box z-[9004] h-[650] w-[365] bg-[#F0F2F5] absolute bottom-[0] left-[0]"
        >
          <div
            class="leading-[46] flex justify-between items-center px-[20] bg-[#fff]"
          >
            <span>咨询帮助-自助服务</span>
            <i class="icon" @click="closeHelp">&#xe641;</i>
          </div>
          <div
            class="container h-[584] px-[20] pb-[16] pt-[12] overflow-y-auto"
          >
            <div class="text-center">
              <!-- <p class="t-[12] t-[#909399] leading-[18]">您好！{{ userName }}</p> -->
              <p class="t-[12] t-[#909399] leading-[18]">
                提供常见问题和便捷CA驱动，助您轻松使用平台
              </p>
            </div>

            <div class="mt-[16] flex justify-start">
              <p class="bg-[#fff] p-[12] rounded-[8] w-[fit-content]">
                您好，很高兴为您服务，您是否需要咨询以下几个问题？
              </p>
            </div>

            <div class="mt-[16] flex justify-start" v-show="helpList.length">
              <div class="bg-[#fff] p-[12] rounded-[8] w-[fit-content]">
                <p class="t-[14] t-[#606266]">您可能要问：</p>
                <p
                  class="t-[theme] t-[14] mt-[8]"
                  v-for="(item, index) in helpList"
                  @click="selectSend(item)"
                >
                  {{ `${index + 1}、${item.title}` }}
                </p>
              </div>
            </div>

            <template v-for="item in questionList">
              <div class="mt-[16] flex justify-start" v-if="item.type == 1">
                <p
                  v-if="item.content.contentType == 0"
                  class="bg-[#fff] p-[12] rounded-[8] w-[fit-content] t-[#303133] break-word max-w-[300]"
                >
                  <span v-html="item.content.content"></span>
                </p>
                <p
                  v-else
                  class="bg-[#fff] p-[12] rounded-[8] w-[fit-content] t-[#303133] break-word max-w-[300]"
                >
                  <span
                    class="t-[#0048FF] underline hover:t-[#551A8B]"
                    @click="wopen(item.content.content.url)"
                    >{{ item.content.content.word }}</span
                  >
                </p>
              </div>
              <div class="mt-[16] flex justify-end" v-else>
                <p
                  class="bg-[theme] p-[12] rounded-[8] w-[fit-content] t-[#fff] break-word max-w-[300]"
                >
                  {{ item.content.title }}
                </p>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from "@/assets/js/mixin";
import { setval } from "@/assets/js/utils";
import xiaojingif from "@/assets/img/xiaojin/xiaojin.gif";
import xiaojin from "@/assets/img/xiaojin/xiaojin.png";
import zhankai from "@/assets/img/xiaojin/zhan_kai.png";
import shouqi from "@/assets/img/xiaojin/shou_qi.png";
// xiaojingif: import("@/assets/img/xiaojin/xiaojin.gif"), //
//       xiaojin: import("/src/assets/img/xiaojin/xiaojin.png"),
//       zhankai: import("@/assets/img/xiaojin/zhan_kai.png"), //
//       shouqi: import("@/assets/img/xiaojin/shou_qi.png"), // 公众号
export default {
  mixins: [mixin],
  name: "dg-xiaojin",
  props: {
    top: String,
    right: String,
    showblank: String,
    value: {
      type: Object,
      default: () => {
        return {
          customerServiceMobile: "",
          customerServicePhone: "",
          customerServicePhone2: "",
          customerServiceTime: "",
          customerServiceTime2: "",
          customerServiceWechatQrcode: "",
        };
      },
    },
    href: String,
  },
  data() {
    return {
      qipao: true,
      isShow: true, //默认展开
      isHover: false,
      copyright: {
        customerServiceMobile: "",
        customerServicePhone: "",
        customerServicePhone2: "",
        customerServiceTime: "",
        customerServiceTime2: "",
        customerServiceWechatQrcode: "",
      },
      xiaojingif,
      xiaojin,
      zhankai,
      shouqi,
      timer: null,
      routerList: {
        GongcSafeLiabilityInsure: ["/notify/list", "/safe/list", "/safe/index"],
        else: ["/notify/list", "/order/index", "/apply/index"],
      },
      content: "",
      userName: "",
      helpList: [],
      questionList: [],
      showEdit: false,
      helpType: "", //咨询类型
      showHelp: false, //是否开始
      showSuccess: false,
      formData: {
        attachment: [], // 附件
        content: "", // 内容描述
        mobile: "", // 手机号码
        serviceType: 0, // 服务类型 0:需求建议 1:产品缺陷
        title: "", // 标题名称
      },
      rules: {
        content: [{ required: true, message: "请填写描述内容" }],
        mobile: [{ required: true, message: "请填写手机号码" }],
        title: [{ required: true, message: "请填写标题" }],
        attachment: [{ required: true, message: "请上传附件" }],
      },
      allFeedbackType: [],
    };
  },
  watch: {
    value: {
      handler(val) {
        setval(this.copyright, val);
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    checkValueNll() {
      if (this.value && Object.keys(this.value).length == 0) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    routerHref(type) {
      // window.fixOpen(process.env.AZXUSER_DOMAIN, "blank")
      if (this.$route.query.taction == "GongcSafeLiabilityInsure") {
        window.fixOpen(
          `${process.config.env.AZXUSER_DOMAIN}#${this.routerList.GongcSafeLiabilityInsure[type]}`,
          "_blank",
        );
      } else {
        window.fixOpen(
          `${process.config.env.domain}#${this.routerList.else[type]}`,
          this.showblank || "_blank",
        );
      }
      // push({path:'/notify/list'},showblank)
    },
    mouseover() {
      this.xiaojin = "";
      this.xiaojin = this.xiaojingif + "?t=" + new Date().getTime();
    },
    pushQuestionList(content, type) {
      let obj = { content: content, type: type };
      this.questionList.push(obj);
      this.$nextTick(() => {
        let container = "";
        container = document.querySelector(".container");
        container.scrollTop = container.scrollHeight - container.clientHeight;
      });
    },
    // 选择问题
    selectSend(item) {
      this.pushQuestionList(item, 2);
      ajax.post({
        url: "/customer/workOrder/external/detail",
        self: this,
        data: { helpId: item.id, ...this.$route.query },
        success: (res) => {
          setTimeout(() => {
            let data = JSON.parse(JSON.stringify(res));
            let content;
            if (res.contentType == 1) {
              content = JSON.parse(res.content);
              data.content = content;
            }
            this.pushQuestionList(data, 1);
          }, 1000);
        },
      });
    },
    getHelpList() {
      ajax.post({
        url: "/customer/workOrder/external/list",
        self: this,
        data: { ...this.$route.query },
        success: (res) => {
          this.helpList = res;
        },
      });
    },
    hanldeSubmit() {
      console.log(this.formData);
      this.$refs.formData.validate((valid) => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.formData));
          let arr = params.attachment.map((item) => {
            return item.value || item.path;
          });
          params.attachment = arr.join(",");
          ajax.post({
            url: "/customer/workOrder/external/create",
            self: this,
            data: { ...params, ...this.$route.query },
            success: () => {
              // console.log(res, 'res')
              this.showSuccess = true;
              this.showEdit = false;
              this.$refs.formData.resetFields();
              this.formData.attachment = [];
              // this.getMobile()
            },
          });
        }
      });
    },
    hanldeDel(key, name) {
      this.formData[name].splice(key, 1);
    },
    inputImg(list, name) {
      this.formData[name] = list;
      console.log(this.formData[name]);
      this.$refs.formData.validateField(name, (err) => {
        if (err) {
          return;
        }
      });
    },
    openHelp(type) {
      Mirror.emit("dg_form_dialog_open");
      this.showSuccess = false;
      this.helpType = type;
      this.showHelp = true;
      this.showEdit = false;
      this.formData = {
        attachment: [], // 附件
        content: "", // 内容描述
        mobile: "", // 手机号码
        title: "", // 标题名称
        serviceType: this.formData.serviceType,
      };
      this.questionList = [];
      // this.getMobile()
      if (type == 2) {
        this.getHelpList();
      }
    },
    closeHelp() {
      Mirror.emit("dg_form_dialog_close");
      this.helpType = "";
      this.showHelp = false;
      this.showSuccess = false;
    },
    changeServiceType(type) {
      this.formData.serviceType = type;
      this.showEdit = false;
      this.$refs.formData.resetFields();
      this.formData.attachment = [];
      // this.getMobile()
    },
    getFeedBackType() {
      ajax.post({
        url: "/customer/common/allFeedbackType",
        data: {},
        self: this,
        success: (res) => {
          this.allFeedbackType = res;
          this.formData.serviceType = res[0].key;
        },
      });
    },
  },
  mounted() {
    this.getFeedBackType()
    // let need = ["/external/channel", "/external/biddingChannel", "/external/bidChannel", "/external/bidSecurity/gongcTenderbidJump"]
    // if (need.includes(this.$route.path) || this.$route.path.indexOf("/external") == -1 || this.$route.path.indexOf("/complete") != -1) {
    //   this.getContact()
    // }
    if (this.top) {
      this.$refs["xiaojin"].style.top = this.top;
    }
    if (this.right) {
      this.$refs["xiaojin"].style.right = this.right;
    }
  },
};
</script>

<style scoped lang="less">
// @import '~@/assets/css/var.less';

#dg__xiaojin {
  position: fixed;
  top: 25%;
  right: 20px;
  width: 78px;
  background: #ffffff;
  box-shadow: 0px 3px 24px 0px rgba(0, 19, 46, 0.1);
  border-radius: 4px 4px 4px 4px;

  .xiaojin-img {
    height: 48px;
    width: 78px;
    background-color: #ffffff;
    position: relative;
    border-radius: 4px 4px 0px 0px;

    .img {
      position: absolute;
      cursor: pointer;
      bottom: 3px;
      left: 50%;
      transform: translate(-50%, 0);
    }

    .qipao {
      left: -20px;
      top: -70px;
      position: absolute;
      width: 92px;
      height: 28px;
      box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.12);
      border-radius: 4px;

      .qipao-item {
        position: relative;
        width: 92px;
        height: 28px;
        color: @theme;

        img {
          position: absolute;
          top: 0;
          left: 0;
        }
      }
    }
  }

  .xiaojin-list {
    width: 78px;
    background-color: #ffffff;
    border-radius: 0px 0px 4px 4px;
    padding-bottom: 34px;
    position: relative;

    .content {
      width: 78px;
      background-color: #ffffff;
      // height: 500px;

      .item {
        width: 78px;
        position: relative;
        height: 68px;
        text-align: center;
        background-color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #303133;

        .hover-icon {
          position: absolute;
          top: 50%;
          transform: translate(0, -50%);
          left: 14px;
        }

        &:hover {
          color: #ffffff;
          background-color: @theme;

          .hover-icon {
            color: #ffffff;
          }
        }
      }
    }

    .show-btn {
      position: absolute;
      bottom: 0;
      left: 0;
      background-color: #f5f7fa;
      height: 34px;
      width: 78px;
      border-radius: 0px 0px 4px 4px;

      .btn-item {
        cursor: pointer;
        border-radius: 0px 0px 4px 4px;
        height: 34px;
        width: 78px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }

  .img1 {
    display: block;
    cursor: pointer;
  }

  .img2 {
    display: block;
  }

  .icon-box {
    width: 42px;
    height: 42px;
    background: @theme;
    border-radius: 100px;
    cursor: pointer;
    padding: 8px;

    i {
      color: #fff;
      font-size: 25px;
    }
  }

  // .content {
  //   background: #fff;
  //   padding: 24px 30px;
  //   min-width: 290px;
  //   position: absolute;
  //   top: 0;
  //   right: 42px;
  //   border-radius: 4px;
  //   box-shadow: 0px 2px 6px 0px rgba(197, 197, 197, 0.22);
  //   display: none;
  // }

  .img-code {
    width: 90px;
    height: 90px;
  }
}

.opacity {
  opacity: 0.5;
}

.help {
  background: #ffffff;
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.12);
  border-radius: 50%;
  border: 1px solid #e4e7ed;
}

.help-box {
  box-shadow: 0px 12px 48px 0px rgba(0, 0, 0, 0.03),
    0px 9px 28px 0px rgba(0, 0, 0, 0.05), 0px 6px 16px 0px rgba(0, 0, 0, 0.08);
  border-radius: 4px 4px 4px 4px;
}

.form-content {
  overflow-y: auto;
}

.help-form .el-form--inline .el-form-item {
  margin-right: 0 !important;
}

.help-form .el-form-item--small.el-form-item {
  margin-bottom: 16px !important;
}
</style>
<style lang="less">
.popper-my {
  padding: 8px 16px;

  .my-pop {
    .tit {
      border-bottom: 1px solid #f0f0f0;
    }
  }
}

.popper-kefu {
  min-width: 100px !important;
  padding: 8px 12px;
}

.popper-feedback {
  z-index: 100 !important;
}

.popper-phone {
  padding: 8px 12px;

  .my-phone {
    .tit {
      border-bottom: 1px solid #f0f0f0;
    }

    .phone {
      height: 16px;
      line-height: 16px;
    }
  }
}

.popper-gzh {
  min-width: 100px !important;
  padding: 8px 12px;
}
</style>
